import Cookies from 'js-cookie'

const TokenKey = 'loginToken'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}



const MchIdKey = 'loginMchId'
export function getMchId() {
  return Cookies.get(MchIdKey)
}

export function setMchId(mchId) {
  return Cookies.set(MchIdKey, mchId?mchId:'')
}

export function removeMchId() {
  return Cookies.remove(MchIdKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js